module.exports = __webpack_public_path__ + "static/unicornsuitcase-5777ac92925e607d6b56076e88a87eab.jpeg";